import { render, staticRenderFns } from "./eventRulesManage.vue?vue&type=template&id=3df8591a&scoped=true&"
import script from "./eventRulesManage.vue?vue&type=script&lang=ts&"
export * from "./eventRulesManage.vue?vue&type=script&lang=ts&"
import style0 from "./eventRulesManage.vue?vue&type=style&index=0&id=3df8591a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df8591a",
  null
  
)

export default component.exports